import { SkinOutlined } from "@ant-design/icons";
import MasterCrudScreen from "./Mastercrudscreen";
import { MASTERS } from "./Masterapi";
import { INDIGO, PURPLE } from "./Mastertheme";

const config = {
    master: MASTERS.fitting,
    title: "Fashion Master",
    singular: "Fashion",
    plural: "Fashions",
    subtitle: "Manage fittings / fashion types",
    icon: <SkinOutlined />,
    from: INDIGO,
    to: PURPLE,
    fields: [
        { name: "fitting", label: "Fashion", placeholder: "e.g. SLIM FIT", required: true, icon: <SkinOutlined /> },
    ],
};

export default function FittingMaster() {
    return <MasterCrudScreen config={config} />;
}